<template>
    <v-container>
        <v-row>
            <v-col>
                <h1>Get in touch!</h1>
            </v-col>
        </v-row>
        <v-row>
            <v-form action="/submit.php" method="post" v-model="valid" lazy-validation>
                <v-container class="text-center">
                    <v-row>
                        <v-col cols=12 class="mb-0">
                            <v-text-field v-model="name" :rules="nameRules" label="Name" single-line solo>
                            </v-text-field>
                        </v-col>
                        <v-col cols=12 class="mt-0 mb-0">
                            <v-text-field v-model="email" :rules="emailRules" label="Email" single-line solo>
                            </v-text-field>
                        </v-col>
                        <v-col cols=12 class="mt-0 mb-0">
                            <v-text-field v-model="subject" :rules="subjectRules" label="Subject" single-line solo>
                            </v-text-field>
                        </v-col>
                        <v-col cols=12 class="mt-0 mb-0">
                            <v-textarea v-model="body" :rules="bodyRules" label="Your inquire" solo />
                        </v-col>
                        <v-col cols=12 class="mt-0 mb-0">
                            <v-checkbox v-model="ispromo" label="Are you sending me promos?"></v-checkbox>
                        </v-col>
                        <v-col cols=12>
                            <v-checkbox v-model="signupNewsletter" label="Subscribe to my newsletter"></v-checkbox>
                        </v-col>
                        <v-col cols="12">
                            <vue-recaptcha size="invisible" @verify="onVerify" @expired="onExpired" ref="invisibleRecaptcha" sitekey="6LfVFf8UAAAAALWrzj22Myc2D_OJtB2YU8U0jHGT"></vue-recaptcha>
                            </v-col>
                        <v-col cols=12>
                            <v-btn :disabled="!valid" color="primary" class="mr-4" @click="submit">
                                Submit
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-form>
        </v-row>
    </v-container>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';

export default {
    name: "Contacts",
    components: { VueRecaptcha },
    data() {
        return {
            recaptcha: false,
            valid: true,
            name: null,
            email: null,
            ispromo: false,
            subject: null,
            body: null,
            promolink: [],
            signupNewsletter: true,
            submitted: false,
            success: false,
            error: false,
            emailRules: [
                v => !!v || 'E-mail is required',
                v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
            ],
            nameRules: [
                v => !!v || 'Name is required',
            ],
            subjectRules: [
                v => !!v || 'Subject is required',
            ],
            bodyRules: [
                v => !!v || 'Inquire content is required',
                v => (v && v.length >= 30) || 'Write me some more details!',
            ]
        }
    },
    methods: {
        submit() {
            this.$refs.invisibleRecaptcha.execute()
            let data = {
                name: this.name,
                email: this.email,
                subject: this.subject,
                body: this.body,
                ispromo: this.ispromo,
                signupNewsletter: this.signupNewsletter
            }
            data = JSON.stringify(data)
            let formData = new FormData()
            formData.append('data', data)
            this.$axios.post('submit.php', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }}).then(() => {
                        this.success = true,
                        this.message = "Message sent correctly"
                    }).catch(() => {
                        this.error = true
                        this.message = "An error occured, please check the form and try again"
                    })
                },
                onVerify (response) {
                    console.log(response)
                },
                onExpired () {
                    this.$router.go(0)
                }
            }

        }
</script>

<style>

</style>